import React, { useEffect, useState } from 'react';
import { AppDispatch } from '../../store.type';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CommonButton from '../common-button/CommonButton';
import {
  getData,
  handleHCHyperLinkOrTextSearch,
  getHelpCenterDeeplinkCMSData
} from '../../screens/help-center/utils/Utils';
import {
  getCountryCode,
  selectHelpCenterReducer,
  selectUserStatusReducer
} from '../../redux/selectors';
import { HELP_CENTER } from '../../utils/constants';
import {
  DeeplinkCMSType,
  FaqNode,
  HelpCenterDeepLinkProps
} from '../../screens/help-center/utils/types';
import {
  enquiryInitiatedBackNav,
  pushToHCHistory,
  toggleIsNavigatedFromDeepLink
} from '../../redux/actions/help-center-action/help-center-actions';
import { activateLoader, disableLoader } from '@Redux/actions/ui-trigger/ui-trigger-action';

const HelpCenterDeepLink = (
  props: HelpCenterDeepLinkProps
): React.ReactElement<HelpCenterDeepLinkProps> | null => {
  const {
    link,
    cmsKey,
    isFromLink = false,
    onClose,
    buttonType = 'link',
    persistCurrentLevelItems
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const countryCode = useSelector(getCountryCode);
  const status = useSelector(selectUserStatusReducer)?.status;
  const currentLevelItems = useSelector(selectHelpCenterReducer)?.currentLevelItems;
  const [cmsData, setCMSData] = useState<DeeplinkCMSType>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getCMSData = async () => {
    const data = await getHelpCenterDeeplinkCMSData();
    const cmsDataFromContentful = data[cmsKey];
    setCMSData(cmsDataFromContentful);
    setIsLoading(false);
  };

  const init = async () => {
    dispatch(activateLoader());
    await getData(dispatch, countryCode, status, persistCurrentLevelItems);
    await getCMSData();
    dispatch(toggleIsNavigatedFromDeepLink(false));
    dispatch(disableLoader());
  };
  useEffect(() => {
    init();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLinkClick = async (
    e: React.MouseEvent<HTMLButtonElement>,
    currentLevelItems: FaqNode,
    dispatch: AppDispatch
  ) => {
    dispatch(activateLoader());
    // Need to set new Current level items and level to 0 before pushing deeplink
    const newCurrentLevelItems: any = persistCurrentLevelItems
      ? await getData(dispatch, countryCode, status)
      : null;
    dispatch(disableLoader());
    onClose?.(true);
    dispatch(toggleIsNavigatedFromDeepLink(true));
    dispatch(pushToHCHistory?.(newCurrentLevelItems || currentLevelItems));
    let pathArray;
    if (isFromLink) {
      const valuesString = link?.split('faqLink=')?.[1];
      pathArray = valuesString?.split('-');
    } else {
      pathArray = cmsData?.linkToFaq;
    }

    e.preventDefault();
    handleHCHyperLinkOrTextSearch(newCurrentLevelItems || currentLevelItems, pathArray, dispatch);
  };

  return !isLoading ? (
    <CommonButton
      text={cmsData?.text || ''}
      type={buttonType}
      onClick={(e) => {
        dispatch(enquiryInitiatedBackNav(false));
        navigate(HELP_CENTER);
        handleLinkClick(e, currentLevelItems, dispatch);
      }}
    />
  ) : null;
};

export { HelpCenterDeepLink };
